import React from "react";
import { Center, VStack, Text, Button, Box } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { GreenTickIcon } from "@root/assets/icons";
import { useTranslation } from "react-i18next";

const Success = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  const handleSignIn = () => {
    navigate("/login");
  };

  return (
    <Center minH="100vh"  px={4} w="474px">
      <VStack spacing={8} maxW="480px" w="100%" textAlign="center">
        <GreenTickIcon />
        
        <VStack spacing={2}>
          <Text fontSize="40px" fontWeight="bold" color="#2F2F34">
            {t("success.title")} {/* e.g. "Success" */}
          </Text>

          <Text fontSize="18px" fontWeight="4oo" color="#2F2F34">
            {t("success.message")} {/* e.g. "Account created successfully!" */}
          </Text>

          <Text fontSize="18px" color="#5C6670" maxW="474px">
            {t("success.description")} {/* e.g. "If you have any further..." */}
          </Text>
        </VStack>

        <Button
          bg="#1819B4"
          color="white"
          size="lg"
          w="100%"
          px={10}
          borderRadius="md"
          _hover={{ bg: "#0000aa" }}
          onClick={handleSignIn}
        >
          {t("success.button")} {/* e.g. "Sign In" */}
        </Button>
      </VStack>
    </Center>
  );
};

export default Success;
